import FormattedMessage from 'I18n/components/FormattedMessage';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Flex } from 'foundations-components/components/Flex';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Link } from 'foundations-components/transitional/components/Link';
import { LinkTypes } from '../../constants/link';
import { hasHublVariable } from '../../utils/hubl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_WIDTH = 175;
export default function LinkPreview({
  href,
  linkDisplayName,
  linkType,
  onAnchorPreviewClick
}) {
  if (!href || linkType === LinkTypes.NONE) {
    return null;
  }
  const handlePreviewLinkClick = evt => {
    if (linkType === LinkTypes.ANCHOR && onAnchorPreviewClick) {
      onAnchorPreviewClick(href);
      evt.preventDefault();
    }
  };
  if (linkType === LinkTypes.EMAIL_SUBSCRIPTION || linkType === LinkTypes.VIEW_AS_WEBPAGE) {
    return /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      "data-test-id": "link-preview",
      paddingInlineStart: "300",
      paddingInlineEnd: "100",
      children: /*#__PURE__*/_jsxs(FormLabel, {
        padding: "0",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "RichTextLib.links.previewLabel.email_subscription"
        }), ' ', /*#__PURE__*/_jsx("span", {
          children: linkDisplayName
        })]
      })
    });
  } else if (hasHublVariable(href)) {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      "data-test-id": "link-preview",
      paddingInlineStart: "300",
      paddingInlineEnd: "100",
      children: [/*#__PURE__*/_jsx(FormLabel, {
        padding: "0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "RichTextLib.links.previewLabel.url"
        })
      }), ' ', /*#__PURE__*/_jsx("span", {
        style: {
          display: 'inline-block',
          verticalAlign: 'middle'
        },
        children: /*#__PURE__*/_jsx(TruncateString, {
          useFlex: true,
          maxWidth: MAX_WIDTH,
          tooltip: false,
          children: href
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": "link-preview",
    paddingInlineStart: "300",
    paddingInlineEnd: linkType === LinkTypes.ANCHOR ? '200' : '100',
    children: [/*#__PURE__*/_jsx(FormLabel, {
      padding: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `RichTextLib.links.previewLabel.${linkType}`
      })
    }), /*#__PURE__*/_jsx(Link, {
      display: "inline-block",
      external: linkType !== LinkTypes.ANCHOR,
      href: href,
      truncate: true,
      truncateStringProps: {
        maxWidth: MAX_WIDTH,
        tooltip: false
      },
      onClick: handlePreviewLinkClick,
      paddingInlineStart: "200",
      children: linkDisplayName
    })]
  });
}